import { Outlet } from 'react-router-dom'
import { SidebarProvider, SidebarTrigger, MainContent } from '../ui/Sidebar'
import OperatorSidebar from './OperatorSidebar'
import NotificationBell from '../NotificationBell'
import AnnouncementBar from '../announcements/AnnouncementBar'
import ChangelogButton from '../changelog/ChangelogButton'
import { BugReportDrawer } from '../feedback'
import { useOperatorWorkspaces } from '../../hooks/useOperatorWorkspaces'

/**
 * Layout route for the back-office. Mounted once around every `/app` page, so
 * the sidebar and the notification poller survive navigation.
 */
export default function OperatorLayout() {
  // Fetched here rather than in the sidebar: this layout mounts once around
  // every /app page, so the switcher survives navigation without refetching.
  const { workspaces, refresh } = useOperatorWorkspaces()

  return (
    <SidebarProvider>
      <OperatorSidebar workspaces={workspaces} onWorkspacesStale={refresh} />

      <MainContent>
        <AnnouncementBar />
        <header className="sticky top-0 z-40 flex h-14 items-center justify-between gap-x-4 border-b border-gray-300 bg-gray-50 px-4 dark:border-gray-800 dark:bg-gray-950/80 sm:px-6 md:justify-end">
          <SidebarTrigger className="md:hidden" />
          <div className="flex items-center gap-1">
            <ChangelogButton />
            <NotificationBell />
          </div>
        </header>

        {/* pb-24 clears the bug-report button, which floats over the bottom
            right corner: without it the last row of a list sits under it with
            no way to scroll further. */}
        <div className="mx-auto w-full max-w-7xl px-4 pb-24 pt-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>

        <BugReportDrawer />
      </MainContent>
    </SidebarProvider>
  )
}
